import Vue from 'vue'
import { SET_LOAN } from './mutations'

const getAuthHeaders = () => {
  const user = JSON.parse(localStorage.getItem('cmsUser'))
  return {
    Authorization: `Bearer ${user.token}`,
  }
}

export default {
  async getLoan({ commit }) {
    const { data } = await Vue.axios.get('loans', {
      params: {
        pagination: false,
      },
      baseURL: process.env.VUE_APP_API_ENDPOINT_V3,
    })

    commit(SET_LOAN, data)

    return data
  },
  async updateLoan({ commit }, loan) {
    const { data } = await Vue.axios.put('loans', loan, {
      baseURL: process.env.VUE_APP_API_ENDPOINT_V3,
      headers: getAuthHeaders(),
    })

    commit(SET_LOAN, data)

    return data
  },
  async createBank({ dispatch }, bankData) {
    const { data } = await Vue.axios.post('loans/banks', bankData, {
      baseURL: process.env.VUE_APP_API_ENDPOINT_V3,
      headers: getAuthHeaders(),
    })

    // Refresh loan data to get updated state
    await dispatch('getLoan')

    return data
  },
  async updateBank({ dispatch }, { id, bankData }) {
    const { data } = await Vue.axios.put(`loans/banks/${id}`, bankData, {
      baseURL: process.env.VUE_APP_API_ENDPOINT_V3,
      headers: getAuthHeaders(),
    })

    // Refresh loan data to get updated state (including reordered banks)
    await dispatch('getLoan')

    return data
  },
}
